import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { ObjectsService } from '@services/objects.service';
import { getObjects, storeObjects } from '@store/actions/objects.actions';

@Injectable()
export class ObjectsEffects {
  private readonly actions$ = inject(Actions);
  private readonly objectsService = inject(ObjectsService);

  getObjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getObjects),
      exhaustMap(() =>
        this.objectsService.objectsList().pipe(
          map((objects) => {
            // this.websocketService.connectAll(objects);
            return storeObjects({ list: objects });
          }),
          catchError(() => EMPTY),
        ),
      ),
    ),
  );
}
